import React from "react";
import "./App.css"; // Import the CSS file for styling


function LabourIndustrialLaw(){

    return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h2>Labour Industrial Law</h2>



    </div>;


}




export default LabourIndustrialLaw;